jQuery(function ($) {


  $('#section-company').on('inview', function(event, isInView) {
    if (isInView) {
      $(this).find('h2').addClass('animate__animated animate__fadeInUp animate__fast');
      $(this).find('#row-company').addClass('animate__animated animate__fadeInLeft');

    } 
  });


  $('.page-company').on('inview', function(event, isInView) {
    if (isInView) {
      $(this).find('#row-company').addClass('animate__animated animate__fadeInLeft');

    } 
  });

  $('#section-service').on('inview', function(event, isInView) {
    if (isInView) {
      $(this).find('h2').addClass('animate__animated animate__fadeInUp animate__fast');

    } 
  });

  $('#section-industry, #section-region').on('inview', function(event, isInView) {
    if (isInView) {
      $(this).find('h2').addClass('animate__animated animate__fadeInUp animate__faster');
      $(this).find('h3').addClass('animate__animated animate__fadeInUp animate__fast');

      $(this).find('#row-industry').addClass('animate__animated animate__fadeInLeft');
      $(this).find('#row-region').addClass('animate__animated animate__fadeInLeft');
      
    } 
  });

  

    $(window).scroll(function () {
        var height = $(window).height();
        if ($(window).scrollTop() > height) {
          $('.p-page_top').addClass('is-active');
        } else {
          $('.p-page_top').removeClass('is-active');
        }
      });
      $('.p-page_top').click(function () {
        $('body, html').animate({ scrollTop: 0 }, 500);
        return false;
     });

     $('#single-product-wrapper .nav-tabs .nav-item:first-child .nav-link').addClass('active');
     $('#single-product-wrapper .tab-content .tab-pane:first-child').addClass('show').addClass('active');


     $('#neutrix-slide').slick({
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
      });

        $('.mw_wp_form [name="accord"]:radio').change( function() {
          var result = $("input[name='accord']:checked").val(); 
          if(result === '同意する'){
                 $('.mw_wp_form table').addClass('writable');
          } else if (result === '同意しない') { 
                 $('.mw_wp_form table').removeClass('writable');
          }
      }).trigger('change');
    

});